define( [ "./selector-sizzle" ], function() {} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 87
// module chunks = 0